'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _style = require('./style');

var _style2 = _interopRequireDefault(_style);

var HIDE_TIMEOUT = 100;

var Tooltip = (function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip() {
    var _this = this;

    _classCallCheck(this, Tooltip);

    _get(Object.getPrototypeOf(Tooltip.prototype), 'constructor', this).apply(this, arguments);

    this.state = {
      active: false
    };

    this.componentDidMount = function () {
      var parent = _reactDom2['default'].findDOMNode(_this).parentNode;

      if (parent.style.position !== 'relative' && parent.style.position !== 'absolute') {
        parent.style.position = 'relative';
      }

      parent.onmouseover = _this.handleParentMouseOver;
      parent.onmouseout = _this.handleParentMouseOut;
    };

    this.handleParentMouseOver = function () {
      setTimeout(function () {
        if (_this.deferredHide) clearTimeout(_this.deferredHide);
        var node = _reactDom2['default'].findDOMNode(_this);
        var parent = node.parentNode;
        var parentStyle = parent.currentStyle || window.getComputedStyle(parent);
        var offset = parseFloat(parentStyle['margin-bottom']) + parseFloat(parentStyle['padding-bottom']);
        var position = parent.getBoundingClientRect();

        node.style.top = position.height - offset + 'px';
        node.style.left = parseInt(position.width / 2 - node.offsetWidth / 2) + 'px';
        if (!_this.state.active) _this.setState({ active: true });
      }, _this.props.delay);
    };

    this.handleParentMouseOut = function () {
      if (_this.state.active) {
        _this.deferredHide = setTimeout(function () {
          _this.setState({ active: false });
        }, HIDE_TIMEOUT);
        console.log(_this.deferredHide);
      }
    };
  }

  _createClass(Tooltip, [{
    key: 'render',
    value: function render() {
      var className = _style2['default'].root;
      if (this.props.className) className += ' ' + this.props.className;
      if (this.state.active) className += ' ' + _style2['default'].active;

      return _react2['default'].createElement(
        'span',
        { 'data-react-toolbox': 'tooltip', className: className },
        this.props.label
      );
    }
  }], [{
    key: 'propTypes',
    value: {
      className: _react2['default'].PropTypes.string,
      delay: _react2['default'].PropTypes.number,
      label: _react2['default'].PropTypes.string
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      className: '',
      delay: 0
    },
    enumerable: true
  }]);

  return Tooltip;
})(_react2['default'].Component);

exports['default'] = Tooltip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/lib/tooltip/index.js
// module id = 462
// module chunks = 0